import { getYesterdayOrBefore } from '@/utils/date';
import moment from 'moment';
import { selectPage } from '@/services/vehicleLineReview';
import { isEmpty } from 'lodash';
import { message } from 'antd';
const [startDate, endDate] = getYesterdayOrBefore();

export default {
  namespace: 'vehicleLineReview',
  state: {
    // 查询条件
    searchParams: {
      firstSortieTimeStart: moment(startDate).format('YYYY-MM-DD'),
      firstSortieTimeEnd: moment(endDate).format('YYYY-MM-DD'),
      selectinput: 'taskNo',
    },
    // 分页
    page: 1,
    pageSize: 50,
    total: 0,

    onSearch: false,
    tableDatas: [],

    exportVisible: false,
    // 导出的表格表头
    tableHeader: null,
  },

  effects: {
    // 分页查询
    *selectPage(_, { call, put, select }) {
      const vehicleLineReview = yield select(({ vehicleLineReview }) => vehicleLineReview);
      const obj = handler(vehicleLineReview);
      const data = yield call(selectPage, obj);

      if (data?.code === 1 && data?.data) {
        yield put({
          type: 'updateState',
          payload: {
            tableDatas: data.data?.rows || [],
            total: data.data?.total || 0,
          },
        });
      } else {
        yield put({
          type: 'updateState',
          payload: {
            tableDatas: [],
            total: 0,
          },
        });
      }
    },
    // 获取导出的分页数据
    *selectExportData({ callback }, { call, select }) {
      const vehicleLineReview = yield select(({ vehicleLineReview }) => vehicleLineReview);
      const obj = handler(vehicleLineReview);
      const data = yield call(selectPage, { ...obj, pageSize: 20000 });

      if (data?.code === 1 && data?.data) {
        if (isEmpty(data.data?.rows)) {
          message.warn('当前查询条件下，无数据可导出！');
        } else {
          callback && callback(data.data?.rows);
        }
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
    resetState(state) {
      return { state, tableDatas: [], offset: undefined };
    },
  },
};

const handler = params => {
  const { page, pageSize, searchParams } = params;
  const {
    firstSortieTimeStart,
    firstSortieTimeEnd,
    selectinput,
    inputvalue,
    centerOrOperatingArea,
    ...others
  } = searchParams;

  const centerOrOperatingAreaParams = {
    centerCode:undefined,
    operatingAreaCode:undefined,
  };
  if (['900100', '900200'].includes(centerOrOperatingArea?.siteTypeCode)) {
    centerOrOperatingAreaParams.centerCode = centerOrOperatingArea?.code;
  }else if ('900800' === centerOrOperatingArea?.siteTypeCode) {
    centerOrOperatingAreaParams.operatingAreaCode = centerOrOperatingArea?.code;
  }

  const queryData = {
    firstSortieTimeStart: moment(firstSortieTimeStart).format('YYYY-MM-DD 12:00:00'),
    firstSortieTimeEnd: moment(firstSortieTimeEnd).format('YYYY-MM-DD 12:00:00'),
    ...others,
    ...centerOrOperatingAreaParams,
  };
  queryData[selectinput] = isEmpty(inputvalue) ? undefined : inputvalue;
  delete queryData.selectinput;
  return {
    page,
    pageSize,
    queryData,
  };
};
